const videoTagSides = {
    LEFT: 'left',
    BOTTOM: 'bottom',
};

export default videoTagSides;
